@if (config(); as templateData) {
  @if (templateData.link; as link) {
    <app-abstract-link [config]="link" [ariaLabel]="templateData.ariaLabel">
      <div class="wrapper">
        @if (templateData.image; as image) {
          <app-image [config]="image" [disableLoadingProgress]="true" />
        }

        @if (templateData.text; as text) {
          <span class="mat-body-small footer-branding-text">{{ text }}</span>
        }
      </div>
    </app-abstract-link>
  } @else {
    <div class="wrapper" [attr.aria-label]="templateData.ariaLabel">
      @if (templateData.image; as image) {
        <app-image [config]="image" [disableLoadingProgress]="true" [disableGhost]="true" />
      }

      @if (templateData.text; as text) {
        <span class="mat-body-small footer-branding-text">{{ text }}</span>
      }
    </div>
  }
}
